import styled from 'styled-components';
import defaultImg from '../img/IMG_0638.JPG';

const StyledHero = styled.header`
    background: url(${props => props.img? props.img : defaultImg}) center/100% no-repeat;
    // display: flex;
    // align-items: center;
    // justify-content: center;
`

export default StyledHero


// WEBPACK FOOTER //
// ./src/components/StyledHero.js